import { useState } from "react";
import { Icon, SectionHeader } from "../../components/public/ui";

const faqs = [
  {
    q: "What is PassEnglishTest?",
    a: "PassEnglishTest is an online learning and exam simulation platform built to help international candidates prepare for Canadian English proficiency tests like the CELPIP General and General LS. We combine computerized test simulations with AI-powered scoring and feedback.",
  },
  {
    q: "How realistic are the practice mock exams?",
    a: "Our mock exams follow the structure, question types, and timers of the official test, so you get used to the screen layout, question counts, and recording timers before test day.",
  },
  {
    q: "What English skills can I practice on the platform?",
    a: "You can practice all four test strands: Listening, Reading, Writing (Task 1 email and Task 2 survey), and Speaking (all 8 speaking tasks with audio recording).",
  },
  {
    q: "Can I access PassEnglishTest from my laptop or mobile phone?",
    a: "Yes! PassEnglishTest works in any modern web browser without plugins. We recommend a desktop or laptop for full mock exams to mirror the actual computer test center setup.",
  },
  {
    q: "Are there free practice tests available?",
    a: "Yes. The Free Starter plan includes 1 full-length mock test and 10 AI-powered Writing and Speaking scores. You don't need to enter payment details to get started.",
  },
];

export const Faqs = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section
      className="w-full py-20 bg-surface-container-low/40 scroll-mt-20"
      id="faqs"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <SectionHeader
          eyebrow="Got Questions?"
          title="Frequently Asked Questions"
          description="Everything you need to know about preparing for your test with PassEnglishTest."
        />
        <div className="space-y-4">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={faq.q}
                className="bg-surface-container-lowest rounded-2xl overflow-hidden transition-all"
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full p-6 text-left flex items-center justify-between gap-4 font-headline-sm text-headline-sm text-on-surface hover:text-primary transition-colors"
                >
                  <span>{faq.q}</span>
                  <Icon
                    name="expand_more"
                    className={`text-primary transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out px-6 ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="pb-6 font-body-md text-body-md text-on-surface-variant leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
